export const validateImageHttp = (image: string, path: string) => {
    const regex = /(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png|jpeg)/;
    return regex.test(image) ? image : `${path}images/${image}`;
}